const lazyStore = {
  store: {},
  persistor: {},
}

export default lazyStore